export default __webpack_public_path__ + "static/media/p1_optimal3.644c2f3b.gif";